angular.module('vastdesk').
  component('supplyTagPodDeduplication', {
    bindings: {
      duplicateEnabledMappings: '<',
      separationEnabledMappings: '<',
      separationMetricMappings: '<',
      duplicateIabTier1Categories: '=',
      iabTier1CategoryMaxDupeAds: '=',
      iabTier1CategorySeparationValue: '=',
      iabTier1CategorySeparationEnabled: '=',
      iabTier1CategorySeparationMetric: '@',
      duplicateIabTier2Categories: '=',
      iabTier2CategoryMaxDupeAds: '=',
      iabTier2CategorySeparationValue: '=',
      iabTier2CategorySeparationEnabled: '=',
      iabTier2CategorySeparationMetric: '@',
      duplicateAdomains: '=',
      adomainCategoryMaxDupeAds: '=',
      adomainSeparationValue: '=',
      adomainSeparationEnabled: '=',
      adomainSeparationMetric: '@',
      duplicateCreatives: '=',
      creativeCategoryMaxDupeAds: '=',
      creativeSeparationValue: '=',
      creativeSeparationEnabled: '=',
      creativeSeparationMetric: '@',
    },
    template: require('../templates/supplyTagPodDeduplication.html'),
    controllerAs: '$supplyTagPodDeduplicationCtrl',
    controller: ['$scope', function ($scope) {
      var self = this;

      this.setDuplicateIabTier1Categories = function (value) {
        self.duplicateIabTier1Categories = value;
      };

      this.setIabTier1CategorySeparationEnabled = function (value) {
        self.iabTier1CategorySeparationEnabled = value;
      };

      this.setDuplicateIabTier2Categories = function (value) {
        self.duplicateIabTier2Categories = value;
      };

      this.setIabTier2CategorySeparationEnabled = function (value) {
        self.iabTier2CategorySeparationEnabled = value;
      };

      this.setDuplicateAdomains = function (value) {
        self.duplicateAdomains = value;
      };

      this.setAdomainSeparationEnabled = function (value) {
        self.adomainSeparationEnabled = value;
      };

      this.setDuplicateCreatives = function (value) {
        self.duplicateCreatives = value;
      };

      this.setCreativeSeparationEnabled = function (value) {
        self.creativeSeparationEnabled = value;
      };
    }],
});
